module.exports = __webpack_public_path__ + "img/visa.2c476a5e.svg";